import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router';
import SliderImport from 'react-slick';

const Slider = SliderImport?.default || SliderImport;

import appSelectors from '@/redux/app/appSelectors';
import ratesSelectors from '@/redux/rates/ratesSelectors';

import ratesOperations from '@/redux/rates/ratesOperations';

import RouteNames from '@/router/routes';

import ArrowLeft from '@/images/arrow-left.svg?react';
import ArrowRight from '@/images/arrow-right.svg?react';

import Container from '@/components/container';
import Rubricator from '@/components/rubricator';

import settings from './slickSettings';
import s from './sectionVpsRates.module.css';
import './slickStyles.css';

const ACC_URL = import.meta.env.VITE_ACC_URL;

function SectionVpsRates() {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const lang = useSelector(appSelectors.language);
  const rates = useSelector(ratesSelectors.vpsPaid);

  const { pathname } = useLocation();

  const sliderRef = useRef();

  const goPrev = () => sliderRef.current.slickPrev();
  const goNext = () => sliderRef.current.slickNext();

  useEffect(() => {
    if (!rates) dispatch(ratesOperations.getRatesVpsPaid());
  }, [dispatch, rates]);

  return (
    <section className={s.section}>
      <Container>
        <div className={s.marker_title_wrapper}>
          <Rubricator single={i18n.тарифы} />
          <p className={s.title}>
            {i18n.стоимость}
            <br />
            {i18n.аренды_VPS}
          </p>
        </div>

        {rates && (
          <div className={s.slider}>
            <Slider {...settings} ref={sliderRef}>
              {rates.map(
                ({
                  id,
                  title,
                  cpu,
                  ram,
                  disk,
                  count,
                  platform,
                  os,
                  network,
                  location,
                  price,
                }) => (
                  <div
                    key={id}
                    className={
                      title.toLowerCase() === 'expert'
                        ? s.card_highlighted
                        : s.card
                    }
                  >
                    {title.toLowerCase() === 'free' && (
                      <Link
                        to={`/${RouteNames.GUIDE}/true-free-vps `}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={s.badge_why_free}
                      >
                        {i18n.почему_бесплатно}?
                      </Link>
                    )}
                    {title.toLowerCase() === 'expert' && (
                      <p className={s.badge_best_offer}>
                        {i18n.лучшее_предложение}
                      </p>
                    )}
                    <p className={s.name}>{title}</p>
                    <ul className={s.params_list}>
                      <li>
                        <p className={s.label}>{i18n.Процессор}:</p>
                        <p className={s.value}>{cpu}</p>
                      </li>
                      <li>
                        <p className={s.label}>{i18n.Оперативная_память}:</p>
                        <p className={s.value}>RAM {ram}</p>
                      </li>
                      <li>
                        <p className={s.label}>{i18n.Объем_диска}:</p>
                        <p className={s.value}>SSD {disk}</p>
                      </li>
                      <li>
                        <p className={s.label}>{i18n.Кол_во_терминалов}:</p>
                        <p className={s.value}>
                          {count} {platform}
                        </p>
                      </li>
                      <li>
                        <p className={s.label}>{i18n.ОС}:</p>
                        <p className={s.value}>{os}</p>
                      </li>
                      <li>
                        <p className={s.label}>{i18n.Трафик}:</p>
                        <p className={s.value}>{network}</p>
                      </li>
                      <li>
                        <p className={s.label}>{i18n.Локация_серверов}:</p>
                        <p className={s.value}>{location}</p>
                      </li>
                    </ul>
                    <p className={s.price}>
                      {i18n.от}:<span>{price}$ /</span>
                      {i18n.месяц}
                    </p>

                    {id === 0 && (
                      <Link
                        to={`/${RouteNames.VPS_FREE}`}
                        className={s.btn_details}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {i18n.подробнее}
                      </Link>
                    )}

                    {id !== 0 && !pathname.includes('vps-paid') && (
                      <Link
                        to={RouteNames.VPS_PAID}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={s.btn_details}
                      >
                        {i18n.приобрести}
                      </Link>
                    )}

                    {id !== 0 && pathname.includes('vps-paid') && (
                      <a
                        href={`${ACC_URL}?lang=${lang}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={s.btn_details}
                      >
                        {i18n.приобрести}
                      </a>
                    )}
                  </div>
                ),
              )}
            </Slider>
          </div>
        )}

        <div className={s.nav_btns}>
          <button
            type="button"
            onClick={goPrev}
            className={s.btn_prev}
            title="prev"
          >
            <ArrowLeft />
          </button>
          <button
            type="button"
            onClick={goNext}
            className={s.btn_next}
            title="next"
          >
            <ArrowRight />
          </button>
        </div>
      </Container>
    </section>
  );
}

export default SectionVpsRates;
